import { render } from "./f4pViewer.vue?vue&type=template&id=8f631b74"
import script from "./f4pViewer.js?vue&type=script&lang=js"
export * from "./f4pViewer.js?vue&type=script&lang=js"

import "./f4pViewer.vue?vue&type=style&index=0&id=8f631b74&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__